import { lazy } from 'react';

const MarketplaceItemDetail = lazy(
	() =>
		import(
			/* webpackChunkName: "marketplace" */
			'./marketplace-detail/marketplace-detail-container.js'
		)
);

export default MarketplaceItemDetail;
